import SearchableDropdown from "./SearchableDropdown";

const FilterBar = ({
  /* SEARCH (optional) */
  searchTerm = "",
  setSearchTerm,

  /* DATE (common) */
  fromDate = "",
  setFromDate,
  toDate = "",
  setToDate,

  /* REGION */
  regionList = [],
  selectedRegion = [],
  setSelectedRegion,

  /* TERRITORY */
  territoryList = [],
  selectedTerritory = [],
  setSelectedTerritory,

  /* PARTY */
  partyList = [],
  selectedParty = [],
  setSelectedParty,

  /* PACK SIZE */
  packSizeList = [],
  selectedPackSize = [],
  setSelectedPackSize,

  /* ACTION */
  onApply,
}) => {
  const handleDateChange = (field, value) => {
    if (field === "startDate") {
      setFromDate?.(value);
    } else if (field === "endDate") {
      setToDate?.(value);
    }
  };

  const inputStyles =
    "w-full border border-slate-300 bg-white rounded-lg px-3 py-2 text-sm text-slate-700 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 transition-all shadow-sm";

  const labelStyles =
    "text-xs font-semibold text-slate-500 mb-1.5 block tracking-wide";

  return (
    <div className="flex flex-wrap items-end gap-5 py-2">

      {/* =========================================================
          DATE INPUTS + APPLY + SEARCH
          ========================================================= */}

      <div className="flex items-end gap-3 bg-slate-50 p-2.5 rounded-xl border border-slate-100 shadow-sm">

        {/* FROM DATE */}
        <div className="flex flex-col min-w-[130px]">
          <label className={labelStyles}>
            From Date
          </label>

          <input
            type="date"
            value={fromDate}
            onChange={(e) =>
              handleDateChange(
                "startDate",
                e.target.value
              )
            }
            className={inputStyles}
          />
        </div>

        {/* TO DATE */}
        <div className="flex flex-col min-w-[130px]">
          <label className={labelStyles}>
            To Date
          </label>

          <input
            type="date"
            value={toDate}
            onChange={(e) =>
              handleDateChange(
                "endDate",
                e.target.value
              )
            }
            className={inputStyles}
          />
        </div>

        {/* APPLY */}
        <button
          onClick={onApply}
          disabled={!fromDate || !toDate}
          className={`h-[38px] px-5 rounded-lg text-sm font-medium transition-all duration-200 flex items-center justify-center ${
            fromDate && toDate
              ? "bg-indigo-600 text-white shadow-md hover:bg-indigo-700 hover:shadow-lg active:scale-95"
              : "bg-slate-100 text-slate-400 border border-slate-200 cursor-not-allowed"
          }`}
        >
          Apply
        </button>

        {/* SEARCH */}
        {setSearchTerm && (
          <div className="flex flex-col min-w-[200px] ml-auto">
            <label className={labelStyles}>
              Search Data
            </label>

            <div className="relative">

              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg
                  className="w-4 h-4 text-slate-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>

              <input
                type="text"
                value={searchTerm}
                onChange={(e) =>
                  setSearchTerm(e.target.value)
                }
                placeholder="Search table..."
                className={`${inputStyles} pl-9`}
              />

            </div>
          </div>
        )}

        {setSelectedRegion && (
          <div className="min-w-[160px]">
            <SearchableDropdown
              label="Zone / Region"
              options={regionList}
              value={selectedRegion}
              onChange={setSelectedRegion}
              disabled={regionList.length === 0}
              isMulti={true}
            />
          </div>
        )}

      </div>

      {/* =========================================================
          DROPDOWNS
          ========================================================= */}

      <div className="flex items-end gap-4">

        {/* =======================================================
            REGION
            ORIGINAL WIDTH PRESERVED
            ======================================================= */}

        {/* {setSelectedRegion && (
          <div className="min-w-[160px]">
            <SearchableDropdown
              label="Zone / Region"
              options={regionList}
              value={selectedRegion}
              onChange={setSelectedRegion}
              disabled={regionList.length === 0}
              isMulti={true}
            />
          </div>
        )} */}

        {/* =======================================================
            TERRITORY
            ORIGINAL WIDTH PRESERVED
            ======================================================= */}

        {setSelectedTerritory && (
          <div className="min-w-[160px]">
            <SearchableDropdown
              label="Territory / Area"
              options={territoryList}
              value={selectedTerritory}
              onChange={setSelectedTerritory}
              disabled={territoryList.length === 0}
              isMulti={true}
            />
          </div>
        )}

        {/* =======================================================
            PARTY
            OVERRIDE WIDTH HERE ONLY
            ======================================================= */}

        {setSelectedParty && (
          <div
            className="
              min-w-[440px]
              w-[550px]
              flex-shrink-0
              [&>div]:!w-full
            "
          >
            <SearchableDropdown
              label="Party"
              options={partyList}
              value={selectedParty}
              onChange={setSelectedParty}
              disabled={partyList.length === 0}
              isMulti={true}
            />
          </div>
        )}

        {/* =======================================================
            PACK SIZE
            OVERRIDE WIDTH HERE ONLY
            ======================================================= */}

        {setSelectedPackSize && (
          <div
            className="
              min-w-[300px]
              w-[350px]
              flex-shrink-0
              [&>div]:!w-full
            "
          >
            <SearchableDropdown
              label="Pack Size"
              options={packSizeList}
              value={selectedPackSize}
              onChange={setSelectedPackSize}
              disabled={packSizeList.length === 0}
              isMulti={true}
            />
          </div>
        )}

      </div>

    </div>
  );
};

export default FilterBar;